module.exports = __webpack_public_path__ + "static/img/zd_light.32dbbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/home/zd_light.png
// module id = 5epB
// module chunks = 1